module.exports = __webpack_public_path__ + "static/img/6.d51c7a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/6.png
// module id = 7BBi
// module chunks = 0